import { render } from "./Selector.vue?vue&type=template&id=0aa17b78&scoped=true&ts=true"
import script from "./Selector.vue?vue&type=script&lang=ts"
export * from "./Selector.vue?vue&type=script&lang=ts"

import "./Selector.vue?vue&type=style&index=0&id=0aa17b78&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aa17b78"]])

export default __exports__